// eslint-disable-next-line no-unused-vars
import { INNER_ROOT, USER_ROOT, transmission, WEB_METHODS } from '../../network/index'

const ROOT = '/coin'

const state = {
  coinDialog: false
}

const mutations = {
  onCoinModal (state, Boolean) {
    state.coinDialog = Boolean
  }
}

/**
 * Actions Naming Rule
 * 기본문법 : CamelCase
 * 작문 : { 메소드 }{ 명칭 }{ 결과타입 }
 *
 * 메소드 예 *
 *  get, post, put, delete 등
 * 명칭 예 *
 *  상담사 : counselor 등
 * 결과 타입 예 *
 *  목록 : List
 *  단건결과 : 없음 등
 */
const actions = {
  /**
   * 사용자 > 코인 > 교환하기 > 교환상세 Api
   * @param commit
   * @param payload
   * @returns {Promise<unknown>}
   */
  // eslint-disable-next-line no-unused-vars
  async exchangeDetail ({commit}, payload) {
    return transmission(true, WEB_METHODS.GET, `${USER_ROOT + ROOT}/exchange`, payload)
  },
    /**
   * 사용자 > 코인 > 코인상세 Api
   * @param commit
   * @param payload
   * @returns {Promise<unknown>}
   */
  // eslint-disable-next-line no-unused-vars
  async coinDetail ({commit}, payload) {
    return transmission(true, WEB_METHODS.GET, `${USER_ROOT + ROOT}/history`, payload)
  },
  /**
   * 사용자 > 코인 > 코인추가 Api
   * @param commit
   * @param payload
   * @returns {Promise<unknown>}
   */

  // async coinAdd ({commit}, payload) {
  //   return transmission(true, WEB_METHODS.POST, `${USER_ROOT + ROOT}/add`, payload)
  // },
  // eslint-disable-next-line no-unused-vars
  async coinAdd ({commit}, payload) {
    return transmission(false, WEB_METHODS.POST, `${INNER_ROOT + ROOT}/add`, payload)
  },
  /**
   * 사용자 > 구매 > 구매하기 > 구매하기 Api
   * @param commit
   * @param payload
   * @returns {Promise<unknown>}
   */
  // eslint-disable-next-line no-unused-vars
  async exchangeGoodsDetail ({commit}, payload) {
    return transmission(true, WEB_METHODS.GET, `${USER_ROOT + ROOT}/exchange/{goodsNo}`, payload)
  },
}

export default { state, mutations, actions }
